import { AxiosError } from "axios";

export class NotificationOptions {
    static presetBase = {
        message: "",
        timeout: 10000,
        icon: "now-ui-icons ui-1_bell-53",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: ""
    };

    static error(message: any): any {
        return this.notificationOptionsPreset(message, NotificationOptions.NotificationTypes.danger);
    }

    static success(message: any): any {
        return this.notificationOptionsPreset(message, NotificationOptions.NotificationTypes.success);
    }

    static notificationOptionsPreset(message: any, typeMessage: NotificationOptions.NotificationTypes): any {
        function isAxiosError(item: any): item is AxiosError {
            return (item as AxiosError).isAxiosError !== undefined;
        }

        let baseMessage = message;
        if (isAxiosError(message)) {
            if (message.response?.data) {
                if (message.response.status === 409) typeMessage = NotificationOptions.NotificationTypes.warning;
                baseMessage = message.response.data;
            }
        }

        if (baseMessage?.message?.length) {
            baseMessage = baseMessage.message;
        } else {
            if (message.errors) baseMessage = message.errors;
            if (message.message) baseMessage = message.message;
        }

        if (message.response?.status === 429) {
            const retryAfter = message.response?.headers?.['retry-after'];
            if (retryAfter) {
                baseMessage = `Too many requests. Please wait ${retryAfter} seconds and try again.`;
            } else {
                baseMessage = `Too many requests. Please wait a moment and try again.`;
            }
            typeMessage = NotificationOptions.NotificationTypes.warning;
        } else if (message.response?.status === 403)
            baseMessage = `You're not authorized to perform this action. ${message.response.data}`;
        else if (typeof message.response?.data === "string" && message.response.data.length)
            baseMessage = `${message.response.data} (${message?.response?.status})`;

        this.presetBase.message = baseMessage;
        this.presetBase.type = NotificationOptions.NotificationTypes[typeMessage];
        return this.presetBase;
    }

    static successSaveNotificationPreset(entityName: string): any {
        this.presetBase.message = `${entityName} Successfully Saved`;
        this.presetBase.type = "success";
        return this.presetBase;
    }

    static successDeletedNotificationPreset(entityName: string): any {
        this.presetBase.message = `${entityName} Successfully Deleted`;
        this.presetBase.type = "success";
        return this.presetBase;
    }

    static errorSaveNotificationPreset(entityName: string, error?: AxiosError): any {
        this.presetBase.message = `${entityName} Failed to Save`;
        this.presetBase.type = "danger";

        if (error?.response?.status === 403)
            this.presetBase.message += `. You are not authorized to perform this save action. ${error.response.data}`;
        else if (typeof error?.response?.data === "string" && error?.response.data.length)
            this.presetBase.message += `. ${error.response.data} (${error?.response?.status})`;

        return this.presetBase;
    }
}

export namespace NotificationOptions {

    export enum NotificationTypes {
        success,
        danger,
        warning,
        info
    }
}
